import { render } from "./tutmon.vue?vue&type=template&id=20323b41&scoped=true&ts=true"
import script from "./tutmon.vue?vue&type=script&lang=ts"
export * from "./tutmon.vue?vue&type=script&lang=ts"

import "./tutmon.vue?vue&type=style&index=0&id=20323b41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20323b41"]])

export default __exports__